import { AccesDecisionService } from "./oauth2/AccesDecisionService";
import { OAuth2Service } from "./oauth2/OAuth2Service";
import PrincipalService from "./oauth2/PrincipalService";
import UtilisateurCycleService from "./oauth2/UtilisateurCycleService";
import makeAxios from "./axios/makeAxios";
import { SnackbarService } from "./snackbar/SnackbarService";
import CommuneService from "./commune/CommuneService";
import PaysService from "./pays/PaysService";
import NationaliteService from "./nationalite/NationaliteService";
import RequeteService from "./requete/RequeteService";
import PiecesService from "./requete/PiecesService";
import DocumentService from "./document/DocumentService";
import InitService from "./init/InitService";
import CaptchaService from "./captcha/CaptchaService";
import AssociationService from "./association/AssociationService";
import ActuatorService from "./actuator/ActuatorService";
import * as axios0 from "axios";

export const oauth2Service = new OAuth2Service();
export const snackbarService = new SnackbarService();
export const accesDecisionService = new AccesDecisionService(oauth2Service);
const axios = makeAxios(oauth2Service, snackbarService);
export const initService = new InitService(axios0);
export const actuatorService = new ActuatorService(axios0, snackbarService);
export const utilisateurCycleService = new UtilisateurCycleService(axios0, snackbarService);
export const principalService = new PrincipalService(axios, snackbarService);
export const documentService = new DocumentService(axios, snackbarService);
export const communeService = new CommuneService(axios, snackbarService);
export const paysService = new PaysService(axios, snackbarService);
export const nationaliteService = new NationaliteService(axios, snackbarService);
export const piecesService = new PiecesService(axios0, axios, snackbarService);
export const requeteService = new RequeteService(axios, snackbarService);
export const captchaService = new CaptchaService(axios0, snackbarService);
export const associationService = new AssociationService(axios, snackbarService);
